import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './PrivacyTermsFooter.module.scss'

const PrivacyTermsFooter = ({ className }) => (
  <footer className={classNames(classes.privacyTermsFooter, 'w-100', className)}>
    <p className={classes.footerText}>
      By continuing you confirm that you have read and agreed to the&nbsp;
      <a href='https://operation36.golf/legal/terms/' target='_blank' rel='noreferrer' className={classes.footerLink}>
        Operation 36 Terms of Use
      </a>
      &nbsp;&middot;&nbsp;
      <a href='https://operation36.golf/legal/privacy/' target='_blank' rel='noreferrer' className={classes.footerLink}>
        Operation 36 Privacy Policy
      </a>
      &nbsp;&middot;&nbsp;
      <a href='https://golfgenius.com/legal/terms-conditions' target='_blank' rel='noreferrer' className={classes.footerLink}>
        Golf Genius Terms of Use
      </a>
      &nbsp;&middot;&nbsp;
      <a href='https://golfgenius.com/legal/privacy' target='_blank' rel='noreferrer' className={classes.footerLink}>
        Golf Genius Privacy Policy
      </a>
    </p>
  </footer>
)

PrivacyTermsFooter.propTypes = {
  className: PropTypes.string,
}

export default PrivacyTermsFooter
